export default __webpack_public_path__ + "static/media/co2Credits.5b3db937.svg";